export default "__VITE_ASSET__BXmJANFZ__"